// extracted by mini-css-extract-plugin
export var avatarContainer = "_8v-0";
export var avatarTypingWave = "_8v-i";
export var gray = "_8v-f";
export var green = "_8v-c";
export var icon = "_8v-9";
export var image = "_8v-1";
export var lg = "_8v-6";
export var md = "_8v-5";
export var presenceDot = "_8v-b";
export var red = "_8v-d";
export var sm = "_8v-4";
export var status = "_8v-a";
export var typingDot = "_8v-h";
export var typingPill = "_8v-g";
export var xl = "_8v-7";
export var xs = "_8v-3";
export var xxl = "_8v-8";
export var xxs = "_8v-2";
export var yellow = "_8v-e";